// @flow
import React from 'react';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { SITEPLAN_PAGE_URL } from 'Routes/constants';

export type FooterSeoProps = {
  ...$Exact<CMSFooterSeo>,
  className?: string,
};

export function FooterSeo({
  className,
  description,
  title,
  siteplanLinkIsDisplayed,
  siteplanLinkLabel,
}: FooterSeoProps) {
  if (!description && !title) {
    return null;
  }

  return (
    <section className={className}>
      <p aria-level="2" className="mb-2 text-sm uppercase" role="heading">
        {title}
      </p>
      <p className="mb-2 reset-paragraph text-base">{description}</p>
      {siteplanLinkIsDisplayed && (
        <DynamicLink
          className="leading-one text-inherit text-sm focus:text-gray-light hover:text-gray-light transition-color"
          url={SITEPLAN_PAGE_URL}
        >
          {siteplanLinkLabel}
        </DynamicLink>
      )}
    </section>
  );
}
